export default {"src":"/_next/static/media/native-plants.5f922df2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};